(ns frontend.view.grid.other-assets-grid.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]
   [common.entity :as entity]
   [common.util :as cu]
   [frontend.state.current-session :as session]))

(defonce other-assets (r/cursor app-db/views [:other-assets-grid]))
(defonce modal-state (r/cursor other-assets [:modals]))
(defonce grid-entities (r/cursor other-assets [:grid-entities]))
(defonce view-settings (r/cursor other-assets [:view-settings]))
(defonce other-asset-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor other-assets [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor other-assets [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor other-assets [:schema]))
